import React, { useState } from "react";
import { RefreshCw, Check, X, Wallet, History } from "lucide-react";

const bs = (v) => `Bs ${Math.round(Number(v || 0)).toLocaleString("es-VE")}`;
const usd = (v) => `$${Number(v || 0).toFixed(2)}`;

const LABEL = {
  awaiting_client: { text: "REAJUSTE PENDIENTE DE ACEPTACIÓN", cls: "text-amber-300 border-amber-500/50 bg-amber-950/30", Icon: RefreshCw },
  accepted: { text: "REAJUSTE ACEPTADO", cls: "text-emerald-300 border-emerald-500/50 bg-emerald-950/30", Icon: Check },
  submitted: { text: "REAJUSTE ACEPTADO · PAGO ENVIADO", cls: "text-cyan-300 border-cyan-500/50 bg-cyan-950/30", Icon: Check },
  completed: { text: "REAJUSTE ACEPTADO Y APLICADO", cls: "text-emerald-300 border-emerald-500/50 bg-emerald-950/30", Icon: Check },
  rejected: { text: "REAJUSTE RECHAZADO POR EL CLIENTE", cls: "text-red-300 border-red-500/50 bg-red-950/30", Icon: X },
};

/** Estado del reajuste en el panel admin + acceso al pedido original (snapshot). */
export const AdminAdjustmentPanel = ({ order }) => {
  const adj = order.adjustment || {};
  const [showOriginal, setShowOriginal] = useState(false);
  const state = LABEL[adj.status];
  if (!state) return null;
  const { Icon } = state;
  const snapshot = adj.orderSnapshot || {};

  return (
    <div className={`p-3 rounded-2xl border space-y-2 ${state.cls}`}
      data-testid={`admin-adjustment-state-${order.id}`}>
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <p className="text-[10px] font-mono uppercase tracking-widest flex items-center gap-1.5">
          <Icon className="w-3.5 h-3.5" /> {state.text}
        </p>
        <p className="text-[10px] font-mono">
          {adj.original?.packageName} → <strong>{adj.proposal?.packageName || adj.newPackageName}</strong>
        </p>
      </div>
      <div className="text-[11px] font-mono grid grid-cols-2 gap-x-3 gap-y-0.5 text-zinc-300">
        <span className="text-zinc-500">Diferencia:</span>
        <strong className="text-right">{bs(adj.differenceBs)} · {usd(adj.differenceUsd)}</strong>
        {Number(adj.creditedToWalletBs || 0) > 0 && (
          <>
            <span className="text-zinc-500 flex items-center gap-1"><Wallet className="w-3 h-3" /> Saldo acreditado:</span>
            <strong className="text-right text-emerald-300" data-testid={`admin-adjustment-credited-${order.id}`}>
              {bs(adj.creditedToWalletBs)}
            </strong>
          </>
        )}
        {Number(adj.extraToPayBs || 0) > 0 && (
          <>
            <span className="text-zinc-500">A pagar por el cliente:</span>
            <strong className="text-right text-amber-300">{bs(adj.extraToPayBs)}</strong>
          </>
        )}
        {adj.finalTotals && (
          <>
            <span className="text-zinc-500">Pedido final:</span>
            <strong className="text-right">{usd(adj.finalTotals.priceUsd)} · costo {usd(adj.finalTotals.costPriceUsd)}</strong>
          </>
        )}
        {adj.rejectionReason && (
          <>
            <span className="text-zinc-500">Motivo del rechazo:</span>
            <strong className="text-right">{adj.rejectionReason}</strong>
          </>
        )}
      </div>
      <button onClick={() => setShowOriginal((v) => !v)}
        data-testid={`admin-adjustment-history-${order.id}`}
        className="text-[10px] font-mono uppercase tracking-widest inline-flex items-center gap-1.5 text-zinc-400 hover:text-white">
        <History className="w-3 h-3" /> {showOriginal ? "Ocultar" : "Ver"} pedido original
      </button>
      {showOriginal && (
        <div className="p-2 rounded-xl bg-black/40 border border-[var(--ag7-border)] text-[11px] font-mono space-y-1">
          <p className="text-zinc-400">
            {snapshot.status} · {usd(snapshot.priceUsd)} · {bs(snapshot.priceBs)} · costo {usd(snapshot.costPriceUsd)}
          </p>
          {(snapshot.items || []).map((it, idx) => (
            <p key={it.id || idx} className="text-zinc-300">
              #{idx + 1} {it.gameName} · {it.packageName} · {usd(it.priceUsd)}
            </p>
          ))}
          {(adj.auditTrail || []).map((entry, idx) => (
            <p key={idx} className="text-[10px] text-zinc-500">
              {entry.event} · {entry.detail}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};
